import { acceptHMRUpdate, defineStore } from 'pinia'
import { getGenericContentSections } from '@shared/api/genericContent.js'
import { ref, computed } from 'vue'

export const useGenericContentStore = defineStore('genericContent', () => {
  const sectionsByLocation = ref([])
  const homepageSectionsLoaded = ref(false)
  const initialSectionsLoaded = computed(() => homepageSectionsLoaded.value)

  async function fetchSections (location) {
    const response = await getGenericContentSections(location)
    sectionsByLocation.value = Array.isArray(response.data) ? response.data : []

    homepageSectionsLoaded.value = true
  }
  async function loadInitialData () {
    // Data needed before the page is displayed should be awaited,
    // otherwise it should be loaded asynchronously in the background.
    fetchSections('homepage')
  }

  const whatMembersSaySection = computed(() => sectionsByLocation.value?.find(section => section.name === 'what_members_say'))
  const heroImageSection = computed(() => sectionsByLocation.value?.find(section => section.name === 'hero_image'))

  return {
    sectionsByLocation,
    fetchSections,
    whatMembersSaySection,
    heroImageSection,
    initialSectionsLoaded,
    loadInitialData
  }
})

import.meta.hot?.accept(acceptHMRUpdate(useGenericContentStore, import.meta.hot))
